<template>
    <div>
        <div class="setting-router-title">勾选需要通知的项</div>
        <div class="setting-main">
            <div class="row">
                <div>
                <a-checkbox
                    v-model:checked="checkAll"
                    :indeterminate="indeterminate"
                    @change="onCheckAllChange"
                    >
                    动态消息
                    </a-checkbox>
                </div>
                <a-checkbox-group v-model:value="checkedList" style="margin-left:27px;margin-top: 10px;">
                    <a-checkbox v-for="item in plainOptions" :key="item.id" :value="item.id" style="margin-right:40px">{{item.text}}</a-checkbox>
                    <!-- <a-checkbox v-for="item in plainOptions[4]" :key="item.id" :value="item.id" style="margin-right:40px">{{item.text}}</a-checkbox> -->
                </a-checkbox-group>
            </div>

            <div class="row">
                <div>
                <a-checkbox
                    v-model:checked="checkAll2"
                    :indeterminate="indeterminate2"
                    @change="onCheckAllChange2"
                    >
                    站内消息
                    </a-checkbox>
                </div>
                <a-checkbox-group v-model:value="checkedList2" style="margin-left:27px;margin-top: 10px;">
                    <a-checkbox v-for="item in plainOptions2" :key="item.id" :value="item.id" style="margin-right:40px">{{item.text}}</a-checkbox>
                </a-checkbox-group>
            </div>

            <div class="divider-line"></div>
        </div>
        <div style="text-align:center">
         <a-button type="primary" @click="setNotice">保存</a-button>

        </div>
    </div>
</template>

<script>
import {defineComponent, onMounted, reactive, toRefs, watch} from 'vue';
import Http from '../../until/http';
import { messageTips } from '../../until/tools';
const plainOptions = [
        {id:1,text:'关注'}, 
        {id:2,text:'评论'}, 
        {id:3,text:'回复'}, 
        {id:4,text:'点赞'},
        {id:10,text:'收藏'}
    ];
const plainOptions2 = [
    {id:8,text:'活动通知'}, 
    {id:9,text:'更新公告'}
];
export default defineComponent({
    setup() {
        const state = reactive({
            indeterminate: false,
            checkAll: false,
            checkedList: [],
            indeterminate2: false,
            checkAll2: false,
            checkedList2: [],
        });
        

        const onCheckAllChange = (e) => {
            Object.assign(state, {
                checkedList: e.target.checked ? plainOptions.map(item=>item.id) : [],
                indeterminate: false,
            });
        };

        const onCheckAllChange2 = (e) => {
            Object.assign(state, {
                checkedList2: e.target.checked ? plainOptions2.map(item=>item.id) : [],
                indeterminate2: false,
            });
        };
        watch(
            () => state.checkedList,
            val => {
                state.indeterminate = !!val.length && val.length < plainOptions.length;
                state.checkAll = val.length === plainOptions.length;
            },
        );
        watch(
            () => state.checkedList2,
            val => {
                state.indeterminate2 = !!val.length && val.length < plainOptions2.length;
                state.checkAll2 = val.length === plainOptions2.length;
            },
        );

        const setNotice = ()=>{
            let ids = [...state.checkedList,...state.checkedList2];
            Http.setNoticeType({ids:ids.join(',')}).then(res=>{
                if(res) {
                    if(res.success) {
                        messageTips(res.message,3);
                    } else {
                        messageTips(res.message,1);
                    }
                }
            })
        }

        onMounted(()=>{
            Http.getNoticeType().then(res=>{
                if(res.list) {
                    if(res.list[2]) {
                        let arr = [];
                        res.list[2].forEach(item=>{
                            if(item.needNotic===1) {
                                arr.push(item.id)
                            }
                        })
                        Object.assign(state,{
                            checkedList2:arr
                        })
                    }
                    if(res.list[3]) {
                        let arr = [];
                        res.list[3].forEach(item=>{
                            if(item.needNotic===1) {
                                arr.push(item.id)
                            }
                        })
                        Object.assign(state,{
                            checkedList:arr
                        })
                    }
                }
            });
        })

        return {
            ...toRefs(state),
            plainOptions,
            plainOptions2,
            onCheckAllChange,
            onCheckAllChange2,
            setNotice
        };
    }
})
</script>

<style>

</style>